import { Configuration, LogLevel } from "@azure/msal-browser";

// This is the name of your B2C sign-up/sign-in user flow
const b2cPolicies = {
    names: {
        signUpSignIn: "B2C_1_signupsignin",
    },
    authorities: {
        signUpSignIn: {
            authority: "https://timindmap.b2clogin.com/timindmap.onmicrosoft.com/B2C_1_signupsignin",
        },
    },
    authorityDomain: "timindmap.b2clogin.com",
};

export const msalConfig: Configuration = {
    auth: {
        clientId: "68b989bd-dd5a-472f-be49-cc61dea2b69c",
        authority: b2cPolicies.authorities.signUpSignIn.authority,
        knownAuthorities: [b2cPolicies.authorityDomain],
        redirectUri: "/",
        postLogoutRedirectUri: "/",
    },
    cache: {
        cacheLocation: "localStorage",
        storeAuthStateInCookie: false,
    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) return;
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    case LogLevel.Info:
                        console.info(message);
                        return;
                    case LogLevel.Verbose:
                        console.debug(message);
                        return;
                    case LogLevel.Warning:
                        console.warn(message);
                        return;
                    default:
                        return;
                }
            },
            logLevel: LogLevel.Verbose,
        },
    },
};

// Scopes required for the backend API
export const apiRequest = {
    //scopes: ["https://timindmap.onmicrosoft.com/68b989bd-dd5a-472f-be49-cc61dea2b69c/access_as_user"],
    scopes: ["https://timindmap.onmicrosoft.com/68b989bd-dd5a-472f-be49-cc61dea2b69c/Reports.Read"],
};

// Scopes required for user sign-in
export const loginRequest = {
    scopes: ["openid", "profile", "offline_access", "email", ...apiRequest.scopes]
};

